import axios from 'axios';

const settings = window.APP_SETTINGS;

export const getExpertRecordDocuments = (orderId, orderRecordId) => {
	return axios.get(`${settings.EXPERT_API_BASE_URL}/orders/${orderId}/order-records/${orderRecordId}/files`);
};
